import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ProgramsHero from './components/ProgramsHero';
import FlagshipProgram from './components/FlagshipProgram';
import ProgramCards from './components/ProgramCards';
import GeographicStrategy from './components/GeographicStrategy';
import LaunchSequence from './components/LaunchSequence';

export default function ProgramsPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <ProgramsHero />
      <FlagshipProgram />
      <ProgramCards />
      <GeographicStrategy />
      <LaunchSequence />
      <Footer />
    </div>
  );
}
